import { createContext } from 'react';
// @ts-ignore
const IdentificationContext = createContext();

export default IdentificationContext;
